import makeResponsive from '../utils/tags/setup_responsive_tag.js'

riot.tag2('riot-legend', '<ul class="simple-charts__legend__list"> <li each="{opts.legendItems}"> <span class="color" riot-style="background-color:{color};"></span> {label} </li> </ul>', '', 'class="simple-charts__legend {opts.cssClasses}" riot-style="{position}"', function(opts) {

  makeResponsive(this)

});





/** WEBPACK FOOTER **
 ** ./src/components/legend.tag
 **/